import { config } from 'config';
import { createTheme } from '@mui/material/styles';
import { orange, teal, pink, amber, deepPurple, blueGrey } from '@mui/material/colors'


const primary = () => {
  switch (config.env) {
    case 'local':
    case 'dev': return amber;
    case 'development': return teal;
    case 'qa': return pink;
    case 'review': return orange;
    case 'staging': return blueGrey;
    case 'live': return deepPurple;
    default: return amber
  }
}

export const theme = createTheme({
  palette: {
    primary: primary()
  },
  typography: {
    fontFamily: [
      'Roboto',
      'Noto Sans KR',
      'Helvetica Neue',
      'Arial',
      'sans-serif'
    ].join(',')
  },
  components: {
    MuiTextField: {
      defaultProps: { variant: 'standard' }
    },
    MuiSelect: {
      defaultProps: { variant: 'standard' }
    }
  },
  spacing: 10
})